<div
	class="sidebar-organization-picker"
	(isOpenChange)="onOpenChange($event)"
	(click)="updateFocus()"
	placement="bottom right"
	dropdown
>
	<a
		class="nav-link"
		data-toggle="dropdown"
		aria-haspopup="true"
		aria-expanded="false"
		dropdownToggle
		data-test-id="org-picker-org-name"
	>
		<div class="nav-mobile-item" *ngIf="currentOrganizationName">
			<span>
				<span [ngClass]="{ blur: applyIncognito$ | async }">{{ currentOrganizationName }}</span>
			</span>
			<img ngSrc="/assets/icons/sidebar-organization-picker-arrow.png" alt="Arrow Down" height="7" width="11" />
		</div>
	</a>

	<div class="dropdown-menu dropdown-menu-right mt-1" *dropdownMenu aria-labelledby="simple-dropdown">
		<div class="dropdown-header text-center" (click)="$event.stopPropagation()">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">
						<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" class="kt-svg-icon">
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<rect x="0" y="0" width="24" height="24" />
								<path
									d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
									fill="#000000"
									fill-rule="nonzero"
									opacity="0.3"
								/>
								<path
									d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
									fill="#000000"
									fill-rule="nonzero"
								/>
							</g>
						</svg>
					</span>
				</div>
				<form [formGroup]="searchTermFormGroup">
					<input
						formControlName="searchTerm"
						#organizationSearchInput
						type="text"
						placeholder="Search"
						autocomplete="off"
						[ngClass]="{ blur: applyIncognito$ | async }"
					/>
				</form>
			</div>
		</div>
		<div class="organization-list">
			<div *ngIf="currentOrganizationName; else organizationsLoading">
				<ng-container *ngFor="let organization of filteredOrganizations | slice : 0 : maxResults">
					<a
						(click)="switchOrganization(organization.org_id)"
						[class.selected]="!!organization.is_selected"
						class="dropdown-item"
					>
						<div *ngIf="isEnableOptHub" class="d-flex align-items-center">
							<img
								[ngSrc]="
									organization.org_cloud_type === organizationTypes.Azure
										? '/assets/azure-logo.svg'
										: '/assets/aws-logo.png'
								"
								alt="organization type image"
								height="24"
								width="24"
								class="cloud-type-img mr-2"
							/>
							<div [class.blur]="applyIncognito$ | async">
								<div [class.text-muted]="!organization.is_active">
									{{ organization.org_name }}<br />
									<span class="text-muted text-sm-80">{{ organization.org_id }}</span>
								</div>
							</div>
						</div>
						<div class="d-flex" *ngIf="!isEnableOptHub">
							<div class="icon mr-2">
								<svg
									[class.non_managed]="!organization.is_managed"
									xmlns="http://www.w3.org/2000/svg"
									class="kt-svg-icon org"
									viewBox="0 0 24 24"
									height="24px"
									width="24px"
								>
									<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
										<rect x="0" y="0" width="24" height="24" />
										<path
											d="M4,9.67471899 L10.880262,13.6470401 C10.9543486,13.689814 11.0320333,13.7207107 11.1111111,13.740321 L11.1111111,21.4444444 L4.49070127,17.526473 C4.18655139,17.3464765 4,17.0193034 4,16.6658832 L4,9.67471899 Z M20,9.56911707 L20,16.6658832 C20,17.0193034 19.8134486,17.3464765 19.5092987,17.526473 L12.8888889,21.4444444 L12.8888889,13.6728275 C12.9050191,13.6647696 12.9210067,13.6561758 12.9368301,13.6470401 L20,9.56911707 Z"
											fill="#000000"
										/>
										<path
											d="M4.21611835,7.74669402 C4.30015839,7.64056877 4.40623188,7.55087574 4.5299008,7.48500698 L11.5299008,3.75665466 C11.8237589,3.60013944 12.1762411,3.60013944 12.4700992,3.75665466 L19.4700992,7.48500698 C19.5654307,7.53578262 19.6503066,7.60071528 19.7226939,7.67641889 L12.0479413,12.1074394 C11.9974761,12.1365754 11.9509488,12.1699127 11.9085461,12.2067543 C11.8661433,12.1699127 11.819616,12.1365754 11.7691509,12.1074394 L4.21611835,7.74669402 Z"
											fill="#000000"
											opacity="0.3"
										/>
									</g>
								</svg>
							</div>
							<div [class.blur]="applyIncognito$ | async">
								<div [class.text-muted]="!organization.is_active">
									{{ organization.org_name }}<br />
									<span class="text-muted text-sm-80">{{ organization.org_id }}</span>
								</div>
							</div>
						</div>
						<app-clipboard-copy [text]="organization.org_id" [outlineView]="true"></app-clipboard-copy>
					</a>
				</ng-container>
			</div>
			<div class="results-count-explanation" *ngIf="filteredOrganizations.length > maxResults">
				Search to find more results
			</div>

			<ng-template #organizationsLoading>
				<div class="p-3 text-center text-muted text-sm-80 animated fadeIn">
					Loading
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24px"
						height="24px"
						viewBox="0 0 24 24"
						class="kt-svg-icon animated fadeIn"
					>
						<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							<rect x="0" y="0" width="24" height="24" />
							<circle fill="#000000" cx="5" cy="12" r="2" />
							<circle fill="#000000" cx="12" cy="12" r="2" />
							<circle fill="#000000" cx="19" cy="12" r="2" />
						</g>
					</svg>
				</div>
			</ng-template>
		</div>
	</div>
</div>

<ng-template #awsImg>
	<svg xmlns="http://www.w3.org/2000/svg" class="kt-svg-icon org" viewBox="0 0 24 24" height="24px" width="24px">
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<rect x="0" y="0" width="24" height="24" />
			<path
				d="M4,9.67471899 L10.880262,13.6470401 C10.9543486,13.689814 11.0320333,13.7207107 11.1111111,13.740321 L11.1111111,21.4444444 L4.49070127,17.526473 C4.18655139,17.3464765 4,17.0193034 4,16.6658832 L4,9.67471899 Z M20,9.56911707 L20,16.6658832 C20,17.0193034 19.8134486,17.3464765 19.5092987,17.526473 L12.8888889,21.4444444 L12.8888889,13.6728275 C12.9050191,13.6647696 12.9210067,13.6561758 12.9368301,13.6470401 L20,9.56911707 Z"
				fill="#000000"
			/>
			<path
				d="M4.21611835,7.74669402 C4.30015839,7.64056877 4.40623188,7.55087574 4.5299008,7.48500698 L11.5299008,3.75665466 C11.8237589,3.60013944 12.1762411,3.60013944 12.4700992,3.75665466 L19.4700992,7.48500698 C19.5654307,7.53578262 19.6503066,7.60071528 19.7226939,7.67641889 L12.0479413,12.1074394 C11.9974761,12.1365754 11.9509488,12.1699127 11.9085461,12.2067543 C11.8661433,12.1699127 11.819616,12.1365754 11.7691509,12.1074394 L4.21611835,7.74669402 Z"
				fill="#000000"
				opacity="0.3"
			/>
		</g>
	</svg>
</ng-template>
